import { render, staticRenderFns } from "./inflections-list.vue?vue&type=template&id=98f7820a&"
import script from "./inflections-list.vue?vue&type=script&lang=js&"
export * from "./inflections-list.vue?vue&type=script&lang=js&"
import style0 from "./inflections-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98f7820a')) {
      api.createRecord('98f7820a', component.options)
    } else {
      api.reload('98f7820a', component.options)
    }
    module.hot.accept("./inflections-list.vue?vue&type=template&id=98f7820a&", function () {
      api.rerender('98f7820a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/morph-parts/inflections-list.vue"
export default component.exports